export const processLiveFeed = (data) => {
  if (data.state && data.state.positions && data.state.positions.length) {
    data.state.positions = data.state.positions.filter((a) => a) || [];
  }

  return data;
};

export const updateToggleLegSelect = (state, action) => {
  let selectedLegs = state.selectedLegs;

  if (!action.value) {
    return selectedLegs;
  }

  selectedLegs = selectedLegs.includes(action.value)
    ? selectedLegs.filter((l) => l !== action.value)
    : [...selectedLegs, action.value];

  return selectedLegs;
};
